import apiFetch from '../apiFetch'

export default function (idTipoDosis) {
  return apiFetch({endPoint: `TipoDosis/deleteTipoDosis?idTipoDosis=` + idTipoDosis, method: 'GET', body: null})
}
